import axios from 'axios';
import ElementUI from 'element-ui';
import { serverIp } from '../../public/config';
import router, {setRouters} from '../router';
import store from '@/store';


//注意 serverIp 来自 config目录的配置文件
const request = axios.create({
    baseURL: `http://${serverIp}:9090`,
    timeout: 30000,
});

request.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (user) {
            config.headers['token'] = user.token;
        }
        return config;
    },
    error => Promise.reject(error)
);

request.interceptors.response.use(
    response => {
        let res = response.data;
        if (response.config.responseType === 'blob') {
            return res;
        }
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res;
        }
        if (res.code === '401') {
            return Promise.reject(new Error('Token 失效'));
        }
        return res;
    },
    error => {

        let message = '请求失败';
        if (error.response) {
            message = `服务端错误: ${error.response.status}`;
            if ((error.response && error.response.status === 401) || error.message === 'Token 失效') {

                ElementUI.Message({
                    message: '登录状态token已失效，请重新登录',
                    type: 'error',
                });

                store.commit('logout');

            }
        } else if (error.request) {
            ElementUI.Message({ message: '网络连接失败，请检查网络', type: 'error' });
        } else {
            ElementUI.Message({ message, type: 'error' });
        }

        return Promise.reject(error);
    }
);

export default request;